import React, { useState } from "react";
import "../assets/WalletMaster.css";

const WalletMaster = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [branchFilter, setBranchFilter] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [employeeFilter, setEmployeeFilter] = useState("");

  const mockData = [
    {
      id: "AGN00001",
      name: "Demo Agent",
      role: "Agent",
      branch: "Muzaffarpur",
      aadhar: "123456789047",
      availableBalance: 109800,
      holdBalance: 500,
    },
    {
      id: "AGN00002",
      name: "Shivam",
      role: "Agent",
      branch: "Muzaffarpur",
      aadhar: "123456789012",
      availableBalance: 1000,
      holdBalance: 600,
    },
  ];

  const filteredData = mockData.filter((user) => {
    return (
      (!branchFilter || user.branch === branchFilter) &&
      (!roleFilter || user.role === roleFilter) &&
      (!employeeFilter || user.name === employeeFilter)
    );
  });

  const handleActionClick = (user) => {
    setSelectedUser(user);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedUser(null);
  };

  const uniqueBranches = [...new Set(mockData.map((user) => user.branch))];
  const uniqueRoles = [...new Set(mockData.map((user) => user.role))];
  const uniqueEmployees = [...new Set(mockData.map((user) => user.name))];

  return (
    <div className="WalletMaster-container">
      <h1 className="WalletMaster-title">Wallet Master</h1>

      <div className="WalletMaster-filters">
        <div>
          <label className="WalletMaster-label">Select Branch</label>
          <select
            className="WalletMaster-select"
            value={branchFilter}
            onChange={(e) => setBranchFilter(e.target.value)}
          >
            <option value="">All Branches</option>
            {uniqueBranches.map((branch, i) => (
              <option key={i} value={branch}>{branch}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="WalletMaster-label">Select Role</label>
          <select
            className="WalletMaster-select"
            value={roleFilter}
            onChange={(e) => setRoleFilter(e.target.value)}
          >
            <option value="">All Roles</option>
            {uniqueRoles.map((role, i) => (
              <option key={i} value={role}>{role}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="WalletMaster-label">Select Employee</label>
          <select
            className="WalletMaster-select"
            value={employeeFilter}
            onChange={(e) => setEmployeeFilter(e.target.value)}
          >
            <option value="">All Employees</option>
            {uniqueEmployees.map((emp, i) => (
              <option key={i} value={emp}>{emp}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="WalletMaster-tableWrapper">
        <table className="WalletMaster-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Name</th>
              <th>History</th>
              <th>Branch</th>
              <th>Role</th>
              <th>Available Balance</th>
              <th>Hold Balance</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((user, index) => (
              <tr key={user.id}>
                <td>{index + 1}</td>
                <td>{user.name}</td>
                <td><button className="WalletMaster-btn history">View</button></td>
                <td>{user.branch}</td>
                <td>{user.role}</td>
                <td>{user.availableBalance.toLocaleString()}</td>
                <td>{user.holdBalance.toLocaleString()}</td>
                <td>
                  <button
                    className="WalletMaster-btn action"
                    onClick={() => handleActionClick(user)}
                  >
                    Action
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modalOpen && selectedUser && (
        <div className="WalletMaster-modalOverlay" onClick={closeModal}>
          <div
            className="WalletMaster-modal WalletMaster-modalScrollable"
            onClick={(e) => e.stopPropagation()}
          >
            <h4 className="WalletMaster-modalTitle">Wallet Action - {selectedUser.name}</h4>
            <div className="WalletMaster-detailItem">
              <div>
                <label className="WalletMaster-label">Employee ID</label>
                <p>{selectedUser.id}</p>
              </div>
              <div>
                <label className="WalletMaster-label">Role</label>
                <p>{selectedUser.role}</p>
              </div>
              <div>
                <label className="WalletMaster-label">Branch</label>
                <p>{selectedUser.branch}</p>
              </div>
              <div>
                <label className="WalletMaster-label">Aadhar</label>
                <p>{selectedUser.aadhar}</p>
              </div>
              <div>
                <label className="WalletMaster-label">Available Balance</label>
                <p>{selectedUser.availableBalance.toLocaleString()}</p>
              </div>
              <div>
                <label className="WalletMaster-label">Hold Balance</label>
                <p>{selectedUser.holdBalance.toLocaleString()}</p>
              </div>
            </div>

            <div className="WalletMaster-walletAction">
              <div>
                <label className="WalletMaster-label">Enter Amount</label>
                <input className="WalletMaster-input" type="number" placeholder="Enter amount" />
              </div>

              <div>
                <label className="WalletMaster-label">Confirm Amount</label>
                <input className="WalletMaster-input" type="number" placeholder="Re-enter amount" />
              </div>

              <div>
                <label className="WalletMaster-label">Wallet Remark</label>
                <input className="WalletMaster-input" type="text" placeholder="Enter remark" />
              </div>

              <div>
                <label className="WalletMaster-label">Select Transaction Type</label>
                <select className="WalletMaster-select">
                  <option value="">Select</option>
                  <option value="add">Add</option>
                  <option value="deduct">Deduct</option>
                  <option value="hold">Hold</option>
                </select>
              </div>

              <div>
                <label className="WalletMaster-label">Pin to Verify Identity</label>
                <input className="WalletMaster-input" type="password" placeholder="Enter PIN" />
              </div>
            </div>

            <div className="WalletMaster-modalButtons">
              <button className="WalletMaster-btn cancel" onClick={closeModal}>Cancel</button>
              <button className="WalletMaster-btn update">Update</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WalletMaster;
